import { Routes } from "@angular/router";

export const routes: Routes = [
  {
    path: "",
    title: "Student Forms",
    loadComponent: () =>
      import("./features/home/home.component").then((m) => m.HomeComponent),
  },
  {
    path: "undergraduate-course-registration",
    title: "Undergraduate Course Registration",
    loadComponent: () =>
      import("./features/forms/undergraduate-course-registration/undergraduate-course-registration.component").then(
        (m) => m.UndergraduateCourseRegistrationComponent,
      ),
  },
  {
    path: "undergraduate-course-extension",
    title: "Undergraduate Course Extension",
    loadComponent: () =>
      import("./features/forms/undergraduate-course-extension/undergraduate-course-extension.component").then(
        (m) => m.UndergraduateCourseExtensionComponent,
      ),
  },
  { path: "**", redirectTo: "", pathMatch: "full" },
];
